<template>
  <div class="purchase-detail-page">
    <div class="purchase-detail-container">
      <!-- 采购详情 -->
      <div class="form-section" style="display: none; justify-content: space-between; align-items: center;" v-if="false">
        <v-table class="purchase-detail-table" hover style="width: 88%">
          <thead>
            <tr>
              <th
                v-for="header in purchaseDetailHeaders"
                :key="header.key"
                :class="['text-' + header.align]"
                :style="{ minWidth: header.width }"
              >
                {{
                  header.key === 'purchaseStandard' && purchaseDetail?.purchaseType === 1
                    ? '送货地址'
                    : header.title
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading" style="height: 60px;">
              <td :colspan="purchaseDetailHeaders.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="!purchaseDetail" style="height: 60px;">
              <td :colspan="purchaseDetailHeaders.length" class="text-center">暂无数据</td>
            </tr>
            <tr v-else style="height: 90px;">
              <td class="text-start" style="word-break: keep-all!important;">
                {{ purchaseDetail.purchaseOrderNo || '-' }}
                <div style="color: #898989">{{ formatNYDate(purchaseDetail.createTime) }}</div>
              </td>
              <td class="text-start">
                <div>{{ purchaseDetail.supplierName || '/' }}</div>
                <div style="color: #898989">{{ purchaseDetail.supplierNo || '/' }}</div>
              </td>
              <td class="text-start">{{ purchaseDetail.paymentCompany || '/' }}</td>
              <td class="text-center">
                <template v-if="purchaseDetail.taxRate">{{ purchaseDetail.taxRate + '%' }}</template>
                <template v-else>/</template>
              </td>
              <td class="text-center">{{ formatNumber(Number(purchaseDetail.taxAmount)) }}</td>
              <td class="text-center">{{ formatNumber(Number(purchaseDetail.totalPrice)) }}</td>
              <td class="text-center">{{ formatNumber(Number(purchaseDetail.totalAmountWithTax)) }}</td>
              <td class="text-center">
                <div class="payment-type">{{ getPaymentMethod(purchaseDetail.paymentType).label || '/' }}</div>
              </td>
              <td class="text-center">
                <template v-if="purchaseDetail.purchaseType === 1">
                  {{ purchaseDetail.deliveryAddress || '/' }}
                </template>
                <template v-else>
                  {{ purchaseDetail.purchaseStandard || '/' }}
                </template>
              </td>
              <td class="text-center">{{ purchaseDetail.warehouseName || '/' }}</td>
              <td class="text-center">{{ purchaseDetail.user?.nickname || '/' }}</td>
              <!-- <td class="text-center" data-key="inboundStatus">
                <div v-if="purchaseDetail.qualityStatus === Number(0)">
                  <img src="@/assets/qualityOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="purchaseDetail.qualityStatus === Number(1)">
                  <img src="@/assets/qualityOn.png" alt="已确认" style="width: 50px;">
                </div>
                <div v-if="purchaseDetail.warehouseStatus === Number(0)">
                  <img src="@/assets/storageOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="purchaseDetail.warehouseStatus === Number(1)">
                  <img src="@/assets/storageOn.png" alt="已确认" style="width: 50px;">
                </div>
              </td> -->
            </tr>
          </tbody>
        </v-table>
        <!-- 采购单二维码 -->
        <div class="qrcode-container" v-if="purchaseDetail?.id">
          <img :src="getQRCodeUrl(purchaseDetail?.id)" alt="采购单二维码" style="height: 146px;">
        </div>
      </div>
      <!-- 明细 -->
      <div class="form-section" style="display: none;" v-if="false">
        <div class="section-title" style="margin-bottom: 16px;margin-top: 30px;">明细</div>
        <v-table class="purchase-detail-table" hover>
          <thead>
            <tr>
              <th v-for="header in detailHead" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td :colspan="detailHead.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="purchaseDetailList.length === 0">
              <td :colspan="detailHead.length" class="text-center">暂无付款记录</td>
            </tr>
            <tr v-else v-for="record in purchaseDetailList" :key="record.id" style="height: 80px;">
              <td class="text-start">
                <div v-if="record.partName">{{ record.partName }}</div>
                <div v-if="record.goodsName">{{ record.goodsName }}</div>
                <div style="color: #898989" v-if="record.goodsSpec">{{ record.goodsSpec }}</div>
                <div style="color: #898989" v-if="record.contractCode">{{ record.contractCode }}</div>
                <div style="color: #898989" v-if="record.goodsNo">{{ record.goodsNo }}</div>
                <div style="color: #898989" v-if="record.batch">{{ record.batch }}</div>
                <div style="color: #898989" v-if="record.syscode">{{ record.syscode }}</div>
              </td>
              <td class="text-left">
                <template v-if="record.type === 0">
                  <!-- <div v-if="!record.bomEstimate && !record.purchasing && !record.inventory" style="text-align: center;">/</div> -->
                  <!-- v-else -->
                    <div class="material-name" style="text-align: left;">料单预估 
                      <span class="material-code">
                        {{ formatOneDecimal(record.bomEstimate) || '/' }}
                        <template v-if="record.bomEstimate">{{ record.bomEstimateUnit }}</template>
                      </span>
                    </div>
                    <div style="text-align: left;">采购中 
                      <span class="material-code">
                        {{ formatOneDecimal(record.purchasing) || '/' }}
                        <template v-if="record.purchasing">{{ record.purchasingUnit }}</template>
                      </span>
                    </div>
                    <div class="material-name" style="text-align: left;">
                      库存 
                      <span class="material-code">
                        {{ formatOneDecimal(record.inventory) || '/' }}
                        <template v-if="record.inventory">{{ record.inventoryUnit }}</template>
                      </span>
                    </div>
                </template>
              </td>
              <td class="text-center">
                <div style="text-align: center;">
                  <template v-if="record.productCodes">
                    {{ record.productCodes }}
                    <!-- <div v-for="productCode in record.productCodes" :key="productCode">
                      <div style="margin-bottom: 4px;">{{ productCode }}</div>
                    </div> -->
                  </template>
                  <template v-else>
                    /
                  </template>
                </div>
              </td>
              <!-- <td class="text-center">{{ record.brand || '/' }}</td> -->
              <td class="text-center">{{ record.quantity || '/' }}</td>
              <td class="text-center">{{ record.unit || '/' }}</td>
              <td class="text-center">{{ record.price || '/' }}</td>
              <td class="text-center">{{ formatNumber(Number(record.totalPrice)) || '/' }}</td>
              <td class="text-center">{{ record.remark || '/' }}</td>
              <td class="text-center">{{ formatNYDate(record.plannedDeliveryDate) || '/' }}</td>
              <td class="text-center" data-key="inboundStatus">
                <template v-if="record.goodsName !== '维修费' && record.goodsName !== '运费' && record.goodsName !== '服务费' && record.goodsName !== '委外' && record.goodsName !== '模具费'">
                  <div style="margin-top: 6px;">
                    <template v-if="record.supplierImageStatus === Number(0)">
                      <img src="@/assets/supplierImageOff.png" alt="未确认" style="width: 50px;margin-right: 10px;">
                    </template>
                    <template v-else-if="record.supplierImageStatus === Number(1)">
                      <img src="@/assets/supplierImageOn.png" alt="已确认" style="width: 50px;margin-right: 10px;">
                    </template>
                    <template v-if="record.shipmentStatus === Number(0)">
                      <img src="@/assets/shipmentOff.png" alt="未确认" style="width: 50px;">
                    </template>
                    <template v-else-if="record.shipmentStatus === Number(1)">
                      <img src="@/assets/shipmentOn.png" alt="已确认" style="width: 50px;">
                    </template>
                    <!-- <template v-if="record.guardStatus === Number(0)">
                      <img src="@/assets/doorkeeperOff.png" alt="未确认" style="width: 50px;">
                    </template>
                    <template v-else-if="record.guardStatus === Number(1)">
                      <img src="@/assets/doorkeeperOn.png" alt="已确认" style="width: 50px;">
                    </template> -->
                  </div>
                  <div>
                    <template v-if="record.qualityStatus === Number(0)">
                      <img src="@/assets/qualityOff.png" alt="未确认" style="width: 50px;margin-right: 10px;">
                    </template>
                    <template v-else-if="record.qualityStatus === Number(1)">
                      <img src="@/assets/qualityOn.png" alt="已确认" style="width: 50px;margin-right: 10px;">
                    </template>
                    <template v-if="Number(purchaseDetail.purchaseType) == 0">
                      <template v-if="record.warehouseStatus === Number(0)">
                        <img src="@/assets/storageOff.png" alt="未确认" style="width: 50px;">
                      </template>
                      <template v-else-if="record.warehouseStatus === Number(1)">
                        <img src="@/assets/storageOn.png" alt="已确认" style="width: 50px;">
                      </template>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div>/</div>
                </template>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
      <!-- 付款记录 -->
      <div class="form-section payment-record-block">
        <div class="payment-record-toolbar">
          <div class="payment-record-toolbar-left">
            <div class="section-title payment-record-section-title">付款记录</div>
            <div class="payment-record-meta">已付：{{ formatNumber(Number(purchaseDetail?.paidAmount)) }}</div>
            <div class="payment-record-meta">已付比例：{{ purchaseDetail?.paidRatio && purchaseDetail?.paidRatio !== 0 ? purchaseDetail?.paidRatio + '%' : '/' }}</div>
          </div>
          <!-- <v-btn color="primary" variant="flat" @click="openPaymentDialog" v-if="userType === 'purchase'">新增付款比例</v-btn> -->
        </div>
        <v-table class="purchase-detail-table payment-record-table" hover>
          <thead>
            <tr>
              <th v-for="header in paymentRecordHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td :colspan="paymentRecordHeaders.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="paymentRecords.length === 0">
              <td :colspan="paymentRecordHeaders.length" class="text-center">暂无付款记录</td>
            </tr>
            <tr v-else v-for="(record, index) in paymentRecords" :key="record.id">
              <td class="text-center">{{ record.applyPercentage ? record.applyPercentage + '%' : '/' }}</td>
              <td class="text-center">{{ formatNumber(Number(record.applyAmount)) }}</td>
              <td class="text-center">{{ formatNYDate(record.prepayDate) }}</td>
              <td class="text-center">{{ record.remark || '/' }}</td>
              <td class="text-center">
                <template v-if="record.status !== -1">{{ formatNYDate(record.applyTime) }}</template>
                <template v-else>/</template>
              </td>
              <td class="text-center">
                <template v-if="record.signatoryName && record.signatoryName.length > 0">
                  <div v-for="signatory in record.signatoryName" :key="signatory">
                    {{ signatory }}
                  </div>
                </template>
                <template v-else>
                  <div>/</div>
                </template>
              </td>
              <td class="text-center">
                <template v-if="record.receiptImages && record.receiptImages.length > 0">
                  <div class="image-preview-item">
                    <v-img
                      :src="getImagePreviewUrl(record.receiptImages[0])"
                      contain
                      class="preview-image"
                    ></v-img>
                    <div class="image-actions"  @click="handleImagePreview(record.receiptImages, index, 0, false, 'voucher')">
                      <v-icon 
                        icon="mdi-eye" 
                        size="20"
                        @click.stop="handleImagePreview(record.receiptImages, index, 0, false, 'voucher')"
                      ></v-icon>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="image-preview-item">
                    <img style="width: 100%;height: 100%;" src="@/assets/noImg.jpg" alt="回单">
                  </div>
                </template>
                <!-- <div v-for="receiptImage in record.receiptImages" :key="receiptImage"> -->
                  <!-- <img :src="receiptImage" alt="回单" style="width: 50px;"> -->
                <!-- </div> -->
              </td>
              <!-- <td class="text-center" v-if="userType === 'payment'">
                <template v-if="record.invoiceImages && record.invoiceImages.length > 0">
                  <div class="image-preview-item">
                    <v-img
                      :src="getImagePreviewUrl(record.invoiceImages[0])"
                      contain
                      class="preview-image"
                    ></v-img>
                    <div class="image-actions"  @click="handleImagePreview(record.invoiceImages, index, 0, false, 'voucher')">
                      <v-icon
                        icon="mdi-eye"
                        size="20"
                        @click.stop="handleImagePreview(record.invoiceImages, index, 0, false, 'voucher')"
                      ></v-icon>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="image-preview-item">
                    <img style="width: 100%;height: 100%;" src="@/assets/noImg.jpg" alt="发票">
                  </div>
                </template>
              </td> -->
              <!-- <td class="text-center">
                <v-btn variant="flat" color="primary" style="margin-right: 10px;" @click="applyPayment(record)" v-if="userType === 'purchase' && Number(record.status) === -1">申请签字</v-btn>
                <v-btn variant="tonal" color="error" @click="deletePayment(record)" v-if="userType === 'purchase' && Number(record.status) === -1">删除</v-btn>
                <v-btn variant="flat" color="primary" @click="signPayment(record)" v-if="userType === 'sign'">签字</v-btn>
                <v-btn variant="flat" color="primary" @click="uploadReceipt(record)" v-if="userType === 'payment' && Number(record.status) !== 2">上传回单</v-btn>
                <v-btn style="margin-left: 10px;" variant="flat" color="primary" @click="uploadInvoice(record)" v-if="userType === 'payment' && Number(record.status) !== 2">上传发票</v-btn>
                <div class="status-text payment-record-status" v-if="userType === 'payment' && Number(record.status) === 2">已付款</div>
                <div class="status-text payment-record-status" v-if="userType === 'purchase' && Number(record.status) === 0">待签字</div>
                <div class="status-text payment-record-status" v-if="userType === 'purchase' && Number(record.status) === 1">已签字</div>
                <div class="status-text payment-record-status" v-if="userType === 'purchase' && Number(record.status) === 2">已付款</div>
              </td> -->
            </tr>
          </tbody>
        </v-table>
      </div>

      <div class="form-actions" v-if="authkind === 'edit'" style="display: none;">
        <!-- <v-btn color="primary" variant="flat" @click="handleEditPurchase">编辑</v-btn> -->
        <v-btn color="primary" variant="flat" @click="openEditWithPurchaseDialog">编辑</v-btn>
      </div>
    </div>

    <!-- 统一采购弹窗 -->
    <PurchaseDialog
      ref="purchaseDialogRef"
      :warehouse-options="formattedWarehouseList"
      :contract-id="purchaseDetail?.contractId ?? undefined"
      :contract-code="purchaseDetail?.so"
      :project-name="purchaseDetail?.project"
      @success="onPurchaseDialogSuccess"
    />

    <!-- 上传回单弹窗 -->
    <v-dialog v-model="showUploadInvoiceDialog" max-width="500">
      <FileAndImgUpload
        accept=".pdf,.jpg,.jpeg,.png"
        :multiple="true"
        icon="mdi-file-document"
        acceptText="支持图片、PDF格式"
        @upload="handleUploadInvoice"
      />
    </v-dialog>
    <!-- 新增弹窗 -->
    <v-dialog v-model="paymentDialog" max-width="600px" persistent>
      <v-card class="payment-dialog">
        <v-card-title class="dialog-title">
          <span class="text-h5">新增</span>
          <v-btn icon="mdi-close" variant="text" @click="closePaymentDialog"></v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="paymentFormRef">
            <v-row>
              <v-col cols="4">
                <!-- suffix="%" -->
                <v-text-field
                  v-model="paymentForm.applyPercentage"
                  label="付款比例"
                  persistent-placeholder
                  placeholder="请输入百分比"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  @input="calculateAmount"
                  suffix="%"
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <!-- prefix="¥" -->
                <v-text-field
                  v-model="paymentForm.applyAmount"
                  label="金额"
                  persistent-placeholder
                  placeholder="请输入金额"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  @input="calculatePercentage"
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <div style="position: relative;">
                  <v-text-field
                    v-model="paymentForm.prepayDate"
                    label="预付日期"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    class="native-date-field"
                    @click="openNativeDatePicker"
                  />
                  <!-- 隐藏的原生日期输入框 -->
                  <input
                    ref="nativeDateInput"
                    type="date"
                    v-model="paymentForm.prepayDate"
                    style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                    @change="onNativeDateChange"
                  />
                </div>  
              </v-col>
              <!-- <v-col cols="12" class="py-0">
                <v-alert type="info" variant="tonal" density="compact">
                  <div style="font-size: 12px;">
                    <div>订单总金额: ¥{{ totalAmount }}</div>
                    <div>已付金额: ¥{{ purchaseDetail?.paidAmount || 0 }}</div>
                    <div>未付金额: ¥{{ unpaidAmount }}</div>
                  </div>
                </v-alert>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="paymentForm.remark"
                  label="付款备注"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  rows="1"
                  resize
                  auto-grow
                  maxlength="500"
                  class="auto-grow-textarea"
                  @input="handleRemarkTextareaInput"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="closePaymentDialog">取消</v-btn>
          <v-btn color="primary" variant="flat" @click="submitPaymentApplication" :loading="submitting">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 签字确认弹窗 -->
    <v-dialog v-model="signConfirmDialog" max-width="500px" persistent>
      <v-card class="payment-dialog">
        <v-card-title class="dialog-title">
          <span class="text-h5">签字确认</span>
          <v-btn icon="mdi-close" variant="text" @click="cancelSign"></v-btn>
        </v-card-title>

        <v-card-text>
          <!-- <div style="padding: 24px 0; color: #fff; font-size: 16px;"> -->
            <!-- <div style="margin-bottom: 16px;">
              <span style="color: rgba(255, 255, 255, 0.7);">申请金额：</span>
              <span style="font-weight: 500;">¥{{ currentSignRecord?.applyAmount || 0 }}</span>
            </div>
            <div style="margin-bottom: 16px;" v-if="currentSignRecord?.applyPercentage">
              <span style="color: rgba(255, 255, 255, 0.7);">申请比例：</span>
              <span style="font-weight: 500;">{{ currentSignRecord?.applyPercentage }}%</span>
            </div> -->
            <!-- <div style="margin-top: 24px; padding: 16px; background-color: rgba(255, 255, 255, 0.05); border-radius: 4px;"> -->
              <span style="color: rgba(255, 255, 255, 0.7);">确认要对此付款申请进行签字吗？</span>
            <!-- </div> -->
          <!-- </div> -->
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="cancelSign">取消</v-btn>
          <v-btn color="primary" variant="flat" @click="confirmSign" :loading="loading">确认</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 付款申请确认弹窗 -->
    <v-dialog v-model="applyConfirmDialog" max-width="400px" persistent>
      <v-card class="payment-dialog">
        <v-card-title class="dialog-title">
          <span class="text-h5">付款申请确认</span>
          <v-btn icon="mdi-close" variant="text" @click="cancelApply"></v-btn>
        </v-card-title>
        <v-card-text>
          <div style="text-align: left; padding: 16px 0;">
            <div style="color: rgba(255, 255, 255, 0.7);">是否提交给主管签字?签字后财务会看到这笔付款申请，并操作付款</div>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="cancelApply">取消</v-btn>
          <v-btn color="primary" variant="flat" @click="confirmApply" :loading="applyLoading">确认</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteConfirmDialog" max-width="400">
      <v-card class="payment-dialog">
        <v-card-title class="text-h5">
          确认删除
        </v-card-title>
        <v-card-text style="color:rgba(255, 255, 255, 0.7) !important">
          确定要删除此付款申请吗？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            variant="tonal"
            @click="cancelDelete"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="confirmDelete"
            :loading="deleteLoading"
          >
            确认删除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 发起采购对话框 -->
    <v-dialog
      v-model="showPurchaseDialog"
      max-width="1250"
      height="80vh"
      persistent
    >
      <v-card class="purchase-dialog">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ purchaseData.purchaseOrderNo ? '修改采购' : '发起采购' }}</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closePurchaseDialog"
          />
        </v-card-title>
        <v-card-text>
          <v-form ref="purchaseForm" v-model="purchaseValid">
            <!-- 供应商选择 -->
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  v-model="purchaseData.vendor"
                  v-model:search="vendorSearchText"
                  :items="vendorSearchText ? vendorList : []"
                  :loading="vendorLoading"
                  :no-filter="true"
                  item-title="companyName"
                  item-value="id"
                  label="供应商"
                  placeholder="请输入供应商名搜索"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :no-data-text="vendorSearchText ? '没有找到匹配的供应商' : '请输入供应商名进行搜索'"
                  clearable
                  return-object
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      :title="item.raw.companyName"
                      :subtitle="item.raw.type ? `${item.raw.type}` : ''"
                    />
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-select
                  v-model="purchaseData.warehouse"
                  :items="formattedWarehouseList"
                  item-title="warehouseName"
                  item-value="warehouseAddress"
                  label="收货仓库"
                  placeholder="请选择收货仓库"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  return-object
                  @update:model-value="handleWarehouseChange"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      :title="item.raw.warehouseName"
                      :subtitle="item.raw.warehouseAddress ? `地址: ${item.raw.warehouseAddress}` : ''"
                    />
                  </template>
                </v-select>
              </v-col>
              <v-col cols="5">
                <v-select
                  v-model="purchaseData.purchaseStandard"
                  :items="purchaseStandardList"
                  item-title="value"
                  item-value="value"
                  label="采购标准"
                  placeholder="请选择采购标准"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  return-object
                />
              </v-col> 
            </v-row>
            <!-- 付款信息 -->
            <v-row class="mt-4">
              <v-col>
                <v-select
                  v-model="purchaseData.paymentMethod"
                  :items="paymentMethods"
                  label="付款方式"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                />
              </v-col>
              <v-col>
                <v-select
                  v-model="purchaseData.taxRate"
                  :items="taxRates"
                  label="税率"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                  return-object
                />
              </v-col>
              <v-col>
                <v-select
                  v-model="purchaseData.tax"
                  :items="taxs"
                  label="是否含税"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                  return-object
                />
              </v-col>
              <v-col>
                <v-select
                  v-model="purchaseData.paymentCompany"
                  :items="paymentCompanys"
                  label="付款公司"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                  return-object
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="purchaseData.taxAmount"
                  label="税额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                  class="v-field--readonly"
                  readonly
                />
              </v-col> 
              <v-col cols="2">
                <v-text-field 
                  label="合计金额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :model-value="purchaseData.totalAmount"
                  type="number"
                  class="v-field--readonly"
                  readonly
                />
              </v-col>
              <v-col cols="2">
                <v-text-field 
                  label="含税总金额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  v-model.number="purchaseData.totalAmountWithTax"
                  type="number"
                  readonly
                  class="v-field--readonly"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="purchaseData.remark"
                  label="采购备注"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details
                  rows="2"
                  resize="false"
                  auto-grow
                  maxlength="500"
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- 物料列表 -->
            <div style="color: #fff; font-size: 16px; font-weight: bold; margin-top: 10px;">物料</div>
            <div class="material-purchase-list">
              <div class="material-purchase-body">
                <div 
                  v-for="(material, index) in selectedMaterialDetails" 
                  :key="material.id || index"
                  class="material-purchase-item"
                >
                  <div style="color:#fff;margin-right: 10px;">{{ index + 1 }}</div>
                  <div class="item-content" style="width: 13%;">
                    <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                    <div style="text-align: left;">{{ material.specDesc }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                  </div>
                  <div class="item-content" style="width: 13%;">
                    <div class="material-name" style="text-align: left;padding-left: 6px;border-left: 3px solid #D2475D;line-height: 1;margin-bottom: 4px;">下单状态</div>
                    <div class="material-name" style="text-align: left;">
                      料单预估 <span class="material-code">
                        {{ formatOneDecimal(material.bomEstimate) || '/' }}
                        <template v-if="material.bomEstimate">{{ material.bomEstimateUnit }}</template>
                      </span>
                    </div>
                    <div style="text-align: left;">
                      采购中 <span class="material-code">
                        {{ formatOneDecimal(material.purchasing) || '/' }}
                        <template v-if="material.purchasing">{{ material.purchasingUnit }}</template>
                      </span>
                    </div>
                    <div class="material-name" style="text-align: left;">
                      库存 <span class="material-code">
                        {{ formatOneDecimal(material.inventory) || '/' }}
                        <template v-if="material.inventory">{{ material.inventoryUnit }}</template>
                      </span>
                    </div>
                  </div>
                  <div class="item-content" style="width: 9%;">
                    <v-text-field
                      v-model="material.materialCount"
                      label="数量"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      @input="handleQuantityInput(material)"
                    >
                    </v-text-field>
                  </div>
                  <div class="item-content" style="width: 100px;">
                    <v-select
                      v-model="material.unit"
                      :items="getUnitListByBigClassOrSmallClass(material.bigClass, material.smallClass)"
                      label="单位"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      item-title="unitName"
                      item-value="unitName"
                      return-object
                      :readonly="!!(material._originalMaterialUnit)" 
                      :class="!!(material._originalMaterialUnit) ? 'v-field--readonly' : ''"
                    />
                  </div>
                  <div class="item-content" style="width: 9%;">
                    <v-text-field
                      v-model="material.materialPrice"
                      label="单价"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      type="number"
                      @input="handlePriceInput(material)"
                    />
                  </div>
                  <div class="item-content" style="width: 13%;">
                    <v-text-field
                      :model-value="calculateTotalPrice(material.materialPrice, material.materialCount)"
                      label="金额"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      class="v-field--readonly"
                      readonly
                    />
                  </div>
                  <div class="item-content">
                    <v-textarea
                      v-model="material.remark"
                      label="物料备注"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      resize
                      auto-grow
                      maxlength="100"
                    ></v-textarea>
                  </div>
                  <div class="item-content" style="width: 180px;position:relative">
                    <v-text-field
                      v-model="material.plannedDeliveryDate"
                      label="计划交货"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      class="native-date-field"
                      @click="openMaterialDatePicker(index)"
                    />
                    <input
                      :ref="el => setMaterialDateInputRef(el, index)"
                      type="date"
                      :value="material.plannedDeliveryDate"
                      :min="getTodayDate()"
                      style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                      @change="(e) => onMaterialDateChange(e, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            variant="flat"
            :loading="purchaseLoading"
            @click="submitPurchase"
          >
            提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 图片预览弹窗 -->
    <ImagePreviewDialog
      v-model="showPreview"
      :image-list="previewImage"
      :current-material-index="currentParentIndex"
      :selected-index="selectedIndex"
      :is-delete="isDelete"
      :type="type"
      @close="handleClosePreview"
      @delete="handleDeleteImage"
    />

    <!-- 公共Loading组件 -->
    <div v-if="showCommonLoading" class="common-loading-overlay">
      <div class="common-loading-container">
        <div class="common-loading-spinner"></div>
        <p class="common-loading-text">{{ commonLoadingText || '加载中...' }}</p>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { ref, onUnmounted, onMounted, computed, nextTick, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { purchaseApi, goodsManageApi, contractApi, type PurchaseOrder, type PaymentApplicationItem } from '@/services/api'
import { useSnackbar } from '@/composables/useSnackbar'
import { useUserStore } from '@/stores/user'
import FileAndImgUpload from '@/components/FileAndImgUpload.vue'
import ImagePreviewDialog from '@/components/ImagePreviewDialog.vue'
import PurchaseDialog from '@/components/PurchaseDialog.vue'


const userStore = useUserStore()

// jf_p_p_s
const router = useRouter()
const route = useRoute()
const { showSuccess, showError } = useSnackbar()

// 采购详情数据
const purchaseDetail = ref<PurchaseOrder | null>(null)
// 付款记录数据
const paymentRecords = ref<PaymentApplicationItem[]>([])
// 采购明细
const purchaseDetailList = ref<PurchaseOrder[]>([])
// 加载状态
const loading = ref(false)

// 新增弹窗状态
const paymentDialog = ref(false)
const submitting = ref(false)
const paymentFormRef = ref()

// 签字确认弹窗状态
const signConfirmDialog = ref(false)
const currentSignRecord = ref<PaymentApplicationItem | null>(null)

// 付款申请确认弹窗状态
const applyConfirmDialog = ref(false)
const applyLoading = ref(false)
const currentApplyRecord = ref<PaymentApplicationItem | null>(null)

// 删除确认弹窗状态
const deleteConfirmDialog = ref(false)
const deleteLoading = ref(false)
const currentDeleteRecord = ref<PaymentApplicationItem | null>(null)

const userType = ref<string>('purchase')
const authkind = ref<string>('see')
// 新增表单数据
const paymentForm = ref({
  applyAmount: '',
  applyPercentage: '',
  prepayDate: '',
  remark: ''
})

// 上传凭证/发票
const currentUploadInvoiceRecord = ref<PaymentApplicationItem | null>(null)
const uploadFileType = ref<'receipt' | 'invoice'>('receipt')
const showUploadInvoiceDialog = ref(false)
const showCommonLoading = ref(false)
const commonLoadingText = ref('')

// ===== 发起采购相关逻辑 =====
interface WarehouseItemOptions {
  warehouseNo: string
  warehouseName: string
  warehouseAddress: string
}

// 仓库列表与下拉选项
const warehouseList = ref<WarehouseItemOptions[]>([])
const unitOptions = ref<any[]>([])
const formattedWarehouseList = computed(() => {
  return warehouseList.value.map(warehouse => ({
    ...warehouse,
    warehouseName: `${warehouse.warehouseName}`
  }))
})

// 统一采购弹窗 ref（编辑时使用）
const purchaseDialogRef = ref<InstanceType<typeof PurchaseDialog> | null>(null)

// 发起采购弹窗相关 state
const showPurchaseDialog = ref(false)
const selectedMaterialDetails = ref<any[]>([])
const purchaseForm = ref()
const purchaseValid = ref(false)
const purchaseLoading = ref(false)
const vendorList = ref<any[]>([])
const vendorLoading = ref(false)
const vendorSearchText = ref('')
const materialDateInputRefs = ref<Record<number, HTMLInputElement | null>>({})

const purchaseData = ref({
  vendor: null as any,
  quantity: null as number | null,
  price: null as number | null,
  purchaseOrderNo: null as string | null,
  paymentMethod: { value: '0', label: '预付' } as any,
  paymentCompany: null as any,
  paymentDate: null as string | null,
  id: null as number | null,
  totalAmount: 0,
  tax: { value: '0', label: '不含税' } as any,
  taxRate: { value: '0', label: '0%' } as any,
  taxAmount: 0,
  totalAmountWithTax: 0,
  warehouse: { warehouseNo: '', warehouseName: '', warehouseAddress: '' } as any,
  purchaseStandard: null as string | null,
  remark: '1、贵公司提供产品保质期最少不得低于二年\n2、凡因供货厂商质量上与我司要求标准有所差异造成的后果，除扣除货款之外还需要负起我司其它之一切损失\n3、供货厂商未依规定期间交货，若因此造成我司所有经济及其名誉上的损失，我司将追究一切之责任\n4、收到清单请及时确认交货期并回传\n5、每周六提供所有订单的交货排程',
})

// 当前编辑的采购订单索引（预留）
const currentPurchaseIndex = ref<number>(-1)

const paymentCompanys = [
  { value: '优罗莎', label: '优罗莎' },
  { value: '上海江丰', label: '上海江丰' }
]

const paymentMethods = [
  { value: '0', label: '预付' },
  { value: '1', label: '现付' },
  { value: '2', label: '月结' },
  { value: '3', label: '次月结' },
]

const purchaseStandardList = [
  'GB/T16799-2018',
  'GB 18401-2010中B级规范',
  'GB 18583-2008有害物质限量',
  '符合39600-2021(EO)(ENF)甲醛释放量',
  'GB/T10802-2023(视产品订定)华为卡座S级其它家具A级',
  'GB/T8624-2012',
  'GB/T9846-2015标准和GB/T14732-2017(环保)',
  'GB/T41919-2020',
  'GB 18581-2020',
  'GB/T44437-2024'
]

const taxs = [
  { value: '0', label: '不含税' },
  { value: '1', label: '含税' }
]

const taxRates = [
  { value: '0', label: '0%' },
  { value: '3', label: '3%' },
  { value: '6', label: '6%' },
  { value: '9', label: '9%' },
  { value: '13', label: '13%' }
]

// 计算采购总金额、税额和含税总金额
const calculatePurchaseTotalAmount = () => {
  const total = selectedMaterialDetails.value.reduce((sum, material) => {
    const quantity = Number(material.materialCount) || 0
    const price = Number(material.materialPrice) || 0
    return sum + quantity * price
  }, 0)
  purchaseData.value.totalAmount = Number(total.toFixed(2))
  calculateTaxAmount()
}

const calculateTaxAmount = () => {
  const totalAmount = purchaseData.value.totalAmount || 0
  const taxRateValue = Number(purchaseData.value.taxRate?.value) || 0

  if (Number(purchaseData.value.tax?.value ?? '0') === 0) {
    const taxAmount = totalAmount * taxRateValue / 100
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number((totalAmount + taxAmount).toFixed(2))
  } else {
    const taxAmount = totalAmount - totalAmount / (1 + taxRateValue / 100)
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number(totalAmount)
  }
}

// 获取今天日期字符串
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 物料日期选择器 ref
const setMaterialDateInputRef = (el: HTMLInputElement | null, index: number) => {
  if (el) {
    materialDateInputRefs.value[index] = el
  }
}

const openMaterialDatePicker = (index: number) => {
  nextTick(() => {
    const input = materialDateInputRefs.value[index]
    if (input) {
      if (typeof (input as any).showPicker === 'function') {
        ;(input as any).showPicker()
      } else {
        input.click()
      }
    }
  })
}

const onMaterialDateChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  try {
    if (newDate && typeof newDate === 'string') {
      const material = selectedMaterialDetails.value[index]
      if (material) {
        material.plannedDeliveryDate = newDate
      }
    }
  } catch (error) {
    console.error('物料日期处理失败:', error)
  }
}

// 金额 = 单价 * 数量（用于物料列表显示）
const calculateTotalPrice = (price: number, quantity: number) => {
  if (!price || !quantity) {
    return '0.00'
  }
  const total = Number(price) * Number(quantity)
  return total.toFixed(2)
}

// 处理数量输入，只允许正整数（复制自 MaterialListSummary）
const handleQuantityInput = (material: any) => {
  let value = String(material.materialCount || '').trim()
  value = value.replace(/[^\d]/g, '')
  if (value === '') {
    material.materialCount = ''
    return
  }
  value = value.replace(/^0+(\d)/, '$1')
  const num = parseInt(value, 10)
  if (!isNaN(num) && num > 0) {
    material.materialCount = num
  } else {
    material.materialCount = ''
  }
}

// 处理单价输入，只允许正数，最多两位小数（复制自 MaterialListSummary）
const handlePriceInput = (material: any) => {
  let value = String(material.materialPrice || '')
  value = value.replace(/[^\d.]/g, '')
  if (value === '' || value === '.') {
    material.materialPrice = ''
    return
  }
  const parts = value.split('.')
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('')
  }
  if (parts.length === 2) {
    if (parts[1].length > 2) {
      value = parts[0] + '.' + parts[1].substring(0, 2)
    }
  }
  if (parts[0].length > 1 && parts[0].startsWith('0')) {
    parts[0] = parts[0].replace(/^0+/, '')
    value = parts.length === 2 ? parts[0] + '.' + parts[1].substring(0, 2) : parts[0]
  }
  const num = parseFloat(value)
  if (!isNaN(num) && num >= 0) {
    material.materialPrice = value
  } else {
    material.materialPrice = ''
  }
}

// 监听物料详情 & 税率变化
watch(
  selectedMaterialDetails,
  () => {
    calculatePurchaseTotalAmount()
  },
  { deep: true }
)

watch(
  () => purchaseData.value.taxRate,
  () => {
    calculateTaxAmount()
  },
  { deep: true }
)

watch(
  () => purchaseData.value.tax,
  () => {
    calculateTaxAmount()
  },
  { deep: true }
)

// 监听供应商变化，自动带出付款方式和税率
watch(
  () => purchaseData.value.vendor,
  (newVendor) => {
    if (newVendor && newVendor.paymentType !== undefined && newVendor.paymentType !== null) {
      const paymentTypeValue = String(newVendor.paymentType)
      const matchedPaymentMethod = paymentMethods.find(item => item.value === paymentTypeValue)
      if (matchedPaymentMethod) {
        purchaseData.value.paymentMethod = matchedPaymentMethod
      }
    }
    if (newVendor && newVendor.rate !== undefined && newVendor.rate !== null) {
      const rateValue = String(newVendor.rate)
      const matchedRate = taxRates.find(item => item.value === rateValue)
      if (matchedRate) {
        purchaseData.value.taxRate = matchedRate
      }
    }
  }
)

// 重置采购表单数据
const resetPurchaseData = () => {
  purchaseData.value = {
    vendor: null,
    quantity: null,
    price: null,
    purchaseOrderNo: null,
    paymentMethod: { value: '0', label: '预付' },
    paymentCompany: null,
    paymentDate: null,
    id: null,
    totalAmount: 0,
    tax: { value: '0', label: '不含税' },
    taxRate: { value: '0', label: '0%' },
    taxAmount: 0,
    totalAmountWithTax: 0,
    warehouse: { warehouseNo: '', warehouseName: '', warehouseAddress: '' } as any,
    purchaseStandard: null,
    remark: '1、贵公司提供产品保质期最少不得低于二年\n2、凡因供货厂商质量上与我司要求标准有所差异造成的后果，除扣除货款之外还需要负起我司其它之一切损失\n3、供货厂商未依规定期间交货，若因此造成我司所有经济及其名誉上的损失，我司将追究一切之责任\n4、收到清单请及时确认交货期并回传\n5、每周六提供所有订单的交货排程',
  }
  materialDateInputRefs.value = {}
  currentPurchaseIndex.value = -1
  vendorSearchText.value = ''
}

// 根据物料编码获取物料信息（库存等）
const getMaterialInfo = async (materialCode: string) => {
  const res = await purchaseApi.purchaseProductQuantityInfo({
    materialCodes: materialCode,
    warehouseNo: purchaseData.value.warehouse.warehouseNo
  } as any)
  if (res?.code === 0 && res.data) {
    selectedMaterialDetails.value.forEach((item: any) => {
      const match = res.data.find((m: any) => m.materialCode === item.materialCode)
      if (match) {
        item.bomEstimate = match.bomEstimate
        item.bomEstimateUnit = match.bomEstimateUnit
        item.inventory = match.inventory
        item.inventoryUnit = match.inventoryUnit
        item.purchasing = match.purchasing
        item.purchasingUnit = match.purchasingUnit
        item.materialPrice = match.price
      }
    })
  }
}

// 处理收货仓库变化时重新拉取物料库存等信息
const handleWarehouseChange = async () => {
  if (purchaseData.value.warehouse && selectedMaterialDetails.value.length > 0) {
    const materialCodes = selectedMaterialDetails.value
      .map((item: any) => item.materialCode)
      .filter((code: string) => code)
      .join(',')

    if (materialCodes) {
      await getMaterialInfo(materialCodes)
    }
  }
}

// 加载供应商列表
const loadVendorList = async () => {
  if (vendorSearchText.value === '' || vendorSearchText.value === null) {
    return
  }
  try {
    vendorLoading.value = true
    const res = await purchaseApi.vendorList({
      page: 1,
      pageSize: 1000,
      keyword: vendorSearchText.value || ''
    } as any)
    if (res?.code === 0 && res.data) {
      vendorList.value = res.data.records
    }
  } catch (error: any) {
    console.error('加载供应商列表失败:', error)
    showError(error.message || '加载供应商列表失败')
  } finally {
    vendorLoading.value = false
  }
}

// 供应商搜索防抖
const vendorSearchDebounce = (() => {
  let timer: number | null = null
  return () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = window.setTimeout(() => {
      loadVendorList()
      timer = null
    }, 300)
  }
})()

watch(vendorSearchText, () => {
  if (purchaseData.value.id !== null || vendorSearchText.value === '') {
    return
  }
  vendorSearchDebounce()
})

// 加载仓库列表
const loadWarehouseList = async () => {
  try {
    const res = await goodsManageApi.getWarehouseList()
    if (res.code === 0) {
      warehouseList.value = res.data || []
    } else {
      warehouseList.value = []
    }
  } catch (error) {
    warehouseList.value = []
  }
}

// 加载单位列表（与物料汇总页一致）
const loadUnitList = async () => {
  const res = await contractApi.getUnitList()
  if (res.code === 0 && res.data) {
    unitOptions.value = res.data as any
  }
}

// 根据大类或小类获取可使用的单位
const getUnitListByBigClassOrSmallClass = (bigClass: string, smallClass: string) => {
  return unitOptions.value.map((item: any) => item.unitName)
}

// 将日期字符串转为时间戳（与物料汇总页面保持一致）
const dateTimestamp = (dateStr: string) => {
  if (!dateStr) return undefined
  try {
    const date = new Date(dateStr)
    date.setHours(0, 0, 0, 0)
    return date.getTime()
  } catch (error) {
    console.error('日期转换失败:', error)
    return undefined
  }
}

// 使用 PurchaseDialog 组件打开编辑（区分实物/服务采购，展示项目名称与合同唯一码）
const openEditWithPurchaseDialog = () => {
  if (!purchaseDetail.value) {
    showError('暂无采购单信息')
    return
  }
  if (!purchaseDetailList.value || purchaseDetailList.value.length === 0) {
    showError('暂无可编辑的物料')
    return
  }
  // 将 productCodes 从字符串转换为数组，传递给 PurchaseDialog
  const materialListForEdit = purchaseDetailList.value.map((item: any) => ({
    ...item,
    productCodes: typeof item.productCodes === 'string'
      ? item.productCodes.split(',').map((code: string) => code.trim()).filter((code: string) => code)
      : (item.productCodes || []),
  }))

  purchaseDialogRef.value?.openForEdit(purchaseDetail.value, materialListForEdit)
}

// 采购弹窗提交成功回调（编辑后刷新详情）
const onPurchaseDialogSuccess = () => {
  fetchPurchaseDetail()
}

// 从采购详情初始化物料和头部信息，并打开发起采购弹窗（原逻辑保留）
const handleEditPurchase = () => {
  if (!purchaseDetail.value) {
    showError('暂无采购单信息')
    return
  }
  if (!purchaseDetailList.value || purchaseDetailList.value.length === 0) {
    showError('暂无可编辑的物料')
    return
  }

  const order: any = purchaseDetail.value

  // 先重置一次，避免旧数据残留
  resetPurchaseData()

  // 供应商
  if (order.vendorId || order.supplierName) {
    purchaseData.value.vendor = {
      id: order.vendorId,
      companyName: order.supplierName,
    }
  }

  // 付款方式
  if (order.paymentType !== undefined && order.paymentType !== null) {
    const paymentTypeValue = String(order.paymentType)
    const matchedPaymentMethod = paymentMethods.find(item => item.value === paymentTypeValue)
    if (matchedPaymentMethod) {
      purchaseData.value.paymentMethod = matchedPaymentMethod
    }
  }

  // 税率
  if (order.taxRate !== undefined && order.taxRate !== null) {
    const rateValue = String(order.taxRate)
    const matchedRate = taxRates.find(item => item.value === rateValue)
    if (matchedRate) {
      purchaseData.value.taxRate = matchedRate
    }
  }

  // 是否含税
  if (order.tax !== undefined && order.tax !== null) {
    const taxValue = String(order.tax)
    const matchedTax = taxs.find(item => item.value === taxValue)
    if (matchedTax) {
      purchaseData.value.tax = matchedTax
    }
  }

  // 付款公司
  if (order.paymentCompany) {
    const matchedCompany = paymentCompanys.find(item => item.value === order.paymentCompany)
    if (matchedCompany) {
      purchaseData.value.paymentCompany = matchedCompany
    }
  }

  // 收货仓库
  if (order.warehouseName) {
    const matchedWarehouse = warehouseList.value.find(w => w.warehouseName === order.warehouseName)
    if (matchedWarehouse) {
      purchaseData.value.warehouse = matchedWarehouse
    } else {
      purchaseData.value.warehouse = {
        warehouseNo: order.warehouseNo || '',
        warehouseName: order.warehouseName,
        warehouseAddress: order.warehouseAddress || ''
      }
    }
  }

  // 金额相关
  purchaseData.value.totalAmount = Number(order.totalPrice ?? order.totalAmountWithTax ?? 0)
  purchaseData.value.taxAmount = Number(order.taxAmount ?? 0)
  purchaseData.value.totalAmountWithTax = Number(order.totalAmountWithTax ?? order.totalPrice ?? 0)

  // 采购标准 & 备注 & 单号
  purchaseData.value.purchaseStandard = order.purchaseStandard || null
  purchaseData.value.remark = order.remark || purchaseData.value.remark
  purchaseData.value.purchaseOrderNo = order.purchaseOrderNo || null

  // 计划交货日期（如果有的话，给原生 date 输入用 YYYY-MM-DD）
  if (order.schDate) {
    purchaseData.value.paymentDate = formatDateForNativeInput(order.schDate)
  }

  selectedMaterialDetails.value = purchaseDetailList.value.map((item: any) => ({
    itemId: item.id,
    materialCode: item.goodsNo,
    materialName: item.goodsName,
    specDesc: item.goodsSpec || '',
    // 物料备注优先使用接口返回的 remark，其次保底用 goodsDesc
    remark: item.remark || item.goodsDesc || '',
    brand: item.brand || '',
    materialRemark: item.materialRemark || '',
    unit: item.unit,
    materialType: item.materialType || '',
    bigClass: item.bigClass || '',
    smallClass: item.smallClass || '',
    plannedDeliveryDate: item.plannedDeliveryDate
      ? formatDateForNativeInput(item.plannedDeliveryDate)
      : (item.schDate ? formatDateForNativeInput(item.schDate) : ''),
    materialCount: item.quantity,
    materialPrice: (item as any).price || 0,
    productCodes: item.productCodes,
  }))

  // 计算一次合计，保持与头部金额一致
  calculatePurchaseTotalAmount()
  showPurchaseDialog.value = true
}

const closePurchaseDialog = () => {
  showPurchaseDialog.value = false
  selectedMaterialDetails.value = []
  resetPurchaseData()
}

// 提交采购（调用后端发起采购接口）
const submitPurchase = async () => {
  if (!purchaseData.value.vendor) {
    showError('请选择供应商')
    return
  }
  if (!purchaseData.value.paymentCompany) {
    showError('请选择付款公司')
    return
  }
  if (!purchaseData.value.warehouse || !purchaseData.value.warehouse.warehouseNo) {
    showError('请选择收货仓库')
    return
  }
  for (let i = 0; i < selectedMaterialDetails.value.length; i++) {
    const m = selectedMaterialDetails.value[i]
    if (m.materialCount == null || m.materialCount === '' || m.materialCount <= 0) {
      showError('请输入物料数量')
      return
    }
    if (m.materialPrice == null || m.materialPrice === '' || m.materialPrice <= 0) {
      showError('请输入物料单价')
      return
    }
    if (m.unit == null || m.unit === '') {
      showError('请选择物料单位')
      return
    }
  }

  const tempMaterialList = selectedMaterialDetails.value
  const materialList: any[] = []
  for (let i = 0; i < tempMaterialList.length; i++) {
    const t = tempMaterialList[i]
    materialList.push({
      materialCode: t.materialCode,
      quantity: t.materialCount,
      price: t.materialPrice,
      remark: t.remark,
      brand: t.brand,
      materialName: t.materialName,
      specDesc: t.specDesc,
      materialRemark: t.materialRemark,
      materialUnit: t.unit,
      materialType: t.materialType,
      bigClass: t.bigClass,
      smallClass: t.smallClass,
      plannedDeliveryDate: t.plannedDeliveryDate,
      itemId: t.itemId,
    })
  }

  try {
    purchaseLoading.value = true
    const submitData: any = {
      id: purchaseDetail.value.id,
      vendorId: purchaseData.value.vendor?.id,
      warehouseNo: purchaseData.value.warehouse?.warehouseNo,
      warehouseName: purchaseData.value.warehouse?.warehouseName,
      paymentCompany: purchaseData.value.paymentCompany.value ?? purchaseData.value.paymentCompany,
      totalAmount: purchaseData.value.totalAmount,
      taxAmount: purchaseData.value.taxAmount,
      totalAmountWithTax: purchaseData.value.totalAmountWithTax,
      tax: purchaseData.value.tax.value,
      taxRate: purchaseData.value.taxRate.value,
      purchaseStandard: purchaseData.value.purchaseStandard,
      materialList,
      schDate: dateTimestamp(purchaseData.value.paymentDate as any),
      paymentType: typeof purchaseData.value.paymentMethod === 'string'
        ? purchaseData.value.paymentMethod
        : purchaseData.value.paymentMethod.value,
      remark: purchaseData.value.remark || ''
    }
    const res = await purchaseApi.purchaseInitiate(submitData as any)
    if (res?.code === 0) {
      showSuccess('采购单创建成功')
      closePurchaseDialog()
      fetchPurchaseDetail()
    } else {
      showError(res?.message || '创建采购单失败')
    }
  } catch (error: any) {
    console.error('创建采购单失败:', error)
    showError(error.message || '创建采购单失败')
  } finally {
    purchaseLoading.value = false
  }
}

// 表单验证规则
const rules = {
  required: (value: any) => !!value || '此项为必填项',
  positiveNumber: (value: any) => {
    if (!value) return true
    const num = parseFloat(value)
    return num > 0 || '金额必须大于0'
  },
  percentage: (value: any) => {
    if (!value) return true
    const num = parseFloat(value)
    return (num > 0 && num <= 100) || '百分比必须在0-100之间'
  }
}

// 计算订单总金额
const totalAmount = computed(() => {
  return purchaseDetail.value.totalAmountWithTax
  // if (!purchaseDetail.value) return 0
  // return (purchaseDetail.value.quantity * purchaseDetail.value.price).toFixed(2)
})

// 计算未付金额
const unpaidAmount = computed(() => {
  // return purchaseDetail.value.totalPrice - purchaseDetail.value.paidAmount

  // const total = parseFloat(totalAmount.value as string)
  // const paid = purchaseDetail.value?.paidAmount || 0
  // return (total - paid).toFixed(2)

  let totalAmount = 0
  paymentRecords.value.forEach((item: any) => {
    totalAmount += item.applyAmount
  })
  return purchaseDetail.value.totalAmountWithTax - totalAmount
})

// 表格列配置
const purchaseDetailHeaders = [
  { title: '采购单号', align: 'start', key: 'purchaseOrderNo', width: '90px' },
  { title: '供应商', align: 'start', key: 'supplierName', width: '180px' },
  { title: '付款公司', align: 'start', key: 'paymentCompany', width: '80px' },
  { title: '税率', align: 'center', key: 'taxRate', width: '50px' },
  { title: '税额', align: 'center', key: 'taxAmount', width: '60px' },
  { title: '合计总额', align: 'center', key: 'totalAmount', width: '100px' },
  { title: '含税总金额', align: 'center', key: 'totalAmount', width: '100px' },
  { title: '付款方式', align: 'center', key: 'paymentType', width: '80px' },
  { title: '采购标准', align: 'center', key: 'purchaseStandard', width: '260px' },
  { title: '收货仓库', align: 'center', key: 'warehouseName', width: '100px' },
  { title: '下单人', align: 'center', key: 'createUserName', width: '90px' },
]

const detailHead = [
  { title: '材料', align: 'center', key: 'goodsName', width: '150px' },
  { title: '下单状态', align: 'center', key: 'orderStatus', width: '100px' },
  { title: '关联产品', align: 'center', key: 'productName', width: '100px' },
  // { title: '品牌', align: 'center', key: 'brand', width: '100px' },
  { title: '数量', align: 'center', key: 'quantity', width: '100px' },
  { title: '单位', align: 'center', key: 'unit', width: '100px' },
  { title: '单价', align: 'center', key: 'price', width: '80px' },
  { title: '总金额', align: 'center', key: 'totalAmount', width: '100px' },
  { title: '物料备注', align: 'center', key: 'remark', width: '100px' },
  { title: '计划交货', align: 'center', key: 'schDate', width: '115px' },
  { title: '入库状态', align: 'center', key: 'inboundStatus', width: '140px' }
]

const paymentRecordHeaders = computed(() => {
  const headers = [
  { title: '比例', align: 'center', key: 'applyPercentage', width: '100px' },
  { title: '金额', align: 'center', key: 'applyAmount', width: '100px' },
  { title: '预付日期', align: 'center', key: 'prepayDate', width: '100px' },
  { title: '备注', align: 'center', key: 'remark', width: '150px' },
  { title: '发起申请', align: 'center', key: 'createTime', width: '140px' },
  { title: '签字人', align: 'center', key: 'signatoryName', width: '100px' },
  { title: '回单', align: 'center', key: 'receiptStatus', width: '100px' },
  // { title: '操作', align: 'center', key: 'actions', width: '100px' },
  ]
  // if (userType.value === 'payment') {
  //   headers.splice(6, 0, { title: '发票', align: 'center', key: 'invoiceStatus', width: '100px' })
  // }
  return headers
})

// 上传回单
const uploadReceipt = (record: PaymentApplicationItem) => {
  showUploadInvoiceDialog.value = true
  uploadFileType.value = 'receipt'
  currentUploadInvoiceRecord.value = record
}

// 上传发票
const uploadInvoice = (record: PaymentApplicationItem) => {
  showUploadInvoiceDialog.value = true
  uploadFileType.value = 'invoice'
  currentUploadInvoiceRecord.value = record
}

const handleUploadInvoice = async(fileInfo: any, index: number) => {
  if(fileInfo.length === 0){
    showUploadInvoiceDialog.value = false
    return
  }
  showCommonLoading.value = true
  commonLoadingText.value = uploadFileType.value === 'receipt' ? '回单上传中...' : '发票上传中...'
  showUploadInvoiceDialog.value = false

  const fileUrls: string[] = []
  fileInfo.forEach((item: any) => {
    fileUrls.push(item.url)
  })
  try {
    const res = uploadFileType.value === 'receipt'
      ? await purchaseApi.purchasePaymentUploadReceipt({
        id: currentUploadInvoiceRecord.value?.id,
        receiptImages: fileUrls
      })
      : await purchaseApi.purchasePaymentUploadInvoice({
        id: currentUploadInvoiceRecord.value?.id,
        invoiceImages: fileUrls
      })
    if(res?.code === 0){
      showSuccess(uploadFileType.value === 'receipt' ? '上传回单成功' : '上传发票成功')
      fetchPurchaseDetail()
    }else{
      showError(res.message)
    }
  } catch (error) {
    showError(error.message || error.msg)
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

// 获取采购详情数据
const fetchPurchaseDetail = async () => {
  const id = route.params.id || route.query.id
  if (!id) {
    showError('缺少采购单ID')
    return
  }

  try {
    loading.value = true
    const response = await purchaseApi.getPurchaseDetail(Number(id))
    
    if (response.code === 0 && response.data) {
      // 设置采购详情数据
      purchaseDetail.value = response.data.order
      if(response.data.order.goodsName){
        document.title = response.data.order.goodsName
      }else{
        document.title = '采购记录'
      }
      // 设置付款记录数据
      if(userType.value === 'sign' || userType.value === 'payment'){
        paymentRecords.value = response.data.paymentApplicationList.filter((item: any) => item.status !== Number(-1))
      }else{
        paymentRecords.value = response.data.paymentApplicationList || []
      }
      paymentRecords.value.forEach((item: any) => {
        if(item.receiptImages && typeof item.receiptImages === 'string'){
          item.receiptImages = JSON.parse(item.receiptImages)
        }
        if(item.invoiceImages && typeof item.invoiceImages === 'string'){
          item.invoiceImages = JSON.parse(item.invoiceImages)
        }
        if(item.signatoryName && typeof item.signatoryName === 'string'){
          item.signatoryName = JSON.parse(item.signatoryName)
        }
      })
      // 采购明细
      purchaseDetailList.value = response.data.itemList || []

      if(userType.value === 'payment'){
        paymentRecords.value = paymentRecords.value.filter((item: any) => item.signatoryName && item.signatoryName.length > 0)
      }
      console.log('采购详情:', purchaseDetail.value)
      console.log('付款记录:', paymentRecords.value)
      console.log('采购明细:', purchaseDetailList.value)
    } else {
      showError(response.msg || '获取采购详情失败')
    }
  } catch (error: any) {
    console.error('获取采购详情失败:', error)
    showError(error.message || '获取采购详情失败')
  } finally {
    loading.value = false
  }
}

const getPaymentMethod = (paymentType: string) => {
  let paymentMethod = {
    value: paymentType,
    label: Number(paymentType) === 0 ? '预付' : Number(paymentType) === 1 ? '现付' : Number(paymentType) === 2 ? '月结' : Number(paymentType) === 3 ? '次月结' : ''
  }
  return paymentMethod
}

// 获取二维码URL
const getQRCodeUrl = (id: number) => {
  // 根据env配置的环境
  if(import.meta.env.VITE_API_BASE_URL){
    return `${import.meta.env.VITE_API_BASE_URL}/jf/purchase/qrcode?id=${id}`;
  }
}

// 数字格式化：最多一位小数；没有小数则不显示 .0
const formatOneDecimal = (val: any) => {
  if (val === null || val === undefined || val === '') return ''
  const num = Number(val)
  if (Number.isNaN(num)) return String(val)
  const rounded = Math.round(num * 10) / 10
  const normalized = rounded === 0 ? 0 : rounded
  if (Number.isInteger(normalized)) {
    return String(normalized)
  }
  return normalized.toFixed(1)
}

// 添加格式化数字的函数
const formatNumber = (num: number) => {
  if(num){
    return num.toLocaleString('en-US')
  } else{
    return '0'
  }
}

// 将时间戳格式化为用于展示的日期（YYYY/MM/DD）
const formatNYDate = (timestamp: number) => {
  if (!timestamp) return '/'
  const date = new Date(timestamp)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '/')
}

// 格式化为原生日期输入框所需的格式 (YYYY-MM-DD)
const formatDateForNativeInput = (date: string | number) => {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 打开新增弹窗
const openPaymentDialog = () => {
  paymentDialog.value = true
  // 重置表单
  paymentForm.value = {
    applyAmount: '',
    applyPercentage: '',
    prepayDate: '',
    remark: ''
  }
}

// 关闭新增弹窗
const closePaymentDialog = () => {
  paymentDialog.value = false
  paymentForm.value = {
    applyAmount: '',
    applyPercentage: '',
    prepayDate: '',
    remark: ''
  }
  paymentFormRef.value?.reset()
}

// 根据金额计算百分比
const calculatePercentage = () => {
  // 如果金额为空，百分比也清空
  if (!paymentForm.value.applyAmount) {
    paymentForm.value.applyPercentage = ''
    return
  }
  
  if (!totalAmount.value) return
  
  const total = parseFloat(totalAmount.value as string)
  
  // 限制金额最多两位小数
  let amountStr = paymentForm.value.applyAmount
  const decimalIndex = amountStr.indexOf('.')
  if (decimalIndex !== -1 && amountStr.length - decimalIndex - 1 > 2) {
    amountStr = parseFloat(amountStr).toFixed(2)
    paymentForm.value.applyAmount = amountStr
  }
  
  let amount = parseFloat(paymentForm.value.applyAmount)
  
  // 限制金额不能大于总金额（精确到小数点）
  if (amount > total) {
    amount = total
    paymentForm.value.applyAmount = total.toFixed(2)
  }
  
  if (total > 0 && amount >= 0) {
    let percentage = Math.round(amount / total * 100)
    
    // 限制百分比最大为100
    if (percentage > 100) {
      percentage = 100
    }
    
    paymentForm.value.applyPercentage = percentage.toString()
  }
}

// 根据百分比计算金额
const calculateAmount = () => {
  // 如果百分比为空，金额也清空
  if (!paymentForm.value.applyPercentage) {
    paymentForm.value.applyAmount = ''
    return
  }
  
  if (!totalAmount.value) return
  
  let percentage = parseInt(paymentForm.value.applyPercentage)
  
  // 确保是整数，不允许小数
  if (isNaN(percentage)) {
    percentage = 0
  }
  
  // 限制百分比在 0-100 之间
  if (percentage < 0) {
    percentage = 0
  } else if (percentage > 100) {
    percentage = 100
  }
  
  // 更新百分比为整数
  paymentForm.value.applyPercentage = percentage.toString()
  
  const total = parseFloat(totalAmount.value as string)
  
  if (percentage > 0 && percentage <= 100) {
    const amount = (total * percentage / 100).toFixed(2)
    paymentForm.value.applyAmount = amount
  } else if (percentage === 0) {
    paymentForm.value.applyAmount = '0'
  }
}

// 提交新增
const submitPaymentApplication = async () => {
  if (!paymentForm.value.applyAmount || parseFloat(paymentForm.value.applyAmount) <= 0) {
    showError('请输入有效的申请金额')
    return
  }

  // if (parseFloat(paymentForm.value.applyAmount) > parseFloat(totalAmount.value as string)) {
  //   showError('申请金额不能大于总金额')
  //   return
  // }

  // let applyPercentage = 0
  // paymentRecords.value.forEach((item: any) => {
  //   applyPercentage += item.applyPercentage
  // })
  // if(applyPercentage + parseFloat(paymentForm.value.applyPercentage) > 100){
  //   showError('申请金额不能大于总金额')
  //   return
  // }


  try {
    submitting.value = true
    const response = await purchaseApi.purchasePaymentApply({
      purchaseOrderId: purchaseDetail.value?.id,
      applyAmount: parseFloat(paymentForm.value.applyAmount),
      applyPercentage: paymentForm.value.applyPercentage ? parseFloat(paymentForm.value.applyPercentage) : undefined,
      prepayDate: paymentForm.value.prepayDate,
      // 保留备注中的换行，统一为 \n 传给后端
      remark: (paymentForm.value.remark || '').replace(/\r\n/g, '\n')
    })
    
    if (response.code === 0) {
      showSuccess('新增提交成功')
      closePaymentDialog()
      fetchPurchaseDetail()
    } else {
      showError(response.message)
    }
  } catch (error: any) {
    console.error('提交新增失败:', error)
    showError(error.message || error.msg)
  } finally {
    submitting.value = false
  }
}

// 打开原生日期选择器
const nativeDateInput = ref<HTMLInputElement>()
const openNativeDatePicker = () => {
  if (nativeDateInput.value) {
    if (nativeDateInput.value.showPicker) {
      nativeDateInput.value.showPicker()
    } else {
      nativeDateInput.value.click()
    }
  }
}

// 原生 HTML5 日期输入框变化处理
const onNativeDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string') {
      // HTML5 date 输入框返回的是 YYYY-MM-DD 格式，直接使用
      paymentForm.value.prepayDate = newDate
    } else {
      paymentForm.value.prepayDate = ''
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    paymentForm.value.prepayDate = ''
  }
}

// 备注输入时等待 DOM 更新后重算高度，确保换行立即生效
const handleRemarkTextareaInput = (event: Event) => {
  const target = event.target as HTMLTextAreaElement
  nextTick(() => {
    target.style.height = 'auto'
    target.style.height = `${target.scrollHeight}px`
  })
}

// 付款申请 - 打开确认弹窗
const applyPayment = (record: PaymentApplicationItem) => {
  currentApplyRecord.value = record
  applyConfirmDialog.value = true
}

// 确认付款申请
const confirmApply = async () => {
  if (!currentApplyRecord.value) return
  
  try {
    applyLoading.value = true
    const response = await purchaseApi.purchasePaymentSubmit({
      id: currentApplyRecord.value.id,
    })
    if(response.code === 0){
      showSuccess('付款申请成功')
      applyConfirmDialog.value = false
      currentApplyRecord.value = null
      await fetchPurchaseDetail()
    }else{
      showError(response.message)
    }
  } finally {
    applyLoading.value = false
  }
}

// 取消付款申请
const cancelApply = () => {
  applyConfirmDialog.value = false
  currentApplyRecord.value = null
}

// 删除付款申请 - 打开确认弹窗
const deletePayment = (record: PaymentApplicationItem) => {
  currentDeleteRecord.value = record
  deleteConfirmDialog.value = true
}

// 确认删除付款申请
const confirmDelete = async () => {
  if (!currentDeleteRecord.value) return
  
  try {
    deleteLoading.value = true
    const response = await purchaseApi.purchasePaymentDelete({
      id: currentDeleteRecord.value.id,
    })
    if(response.code === 0){
      showSuccess('删除成功')
      deleteConfirmDialog.value = false
      currentDeleteRecord.value = null
      await fetchPurchaseDetail()
    }else{
      showError(response.message)
    }
  } finally {
    deleteLoading.value = false
  }
}

// 取消删除
const cancelDelete = () => {
  deleteConfirmDialog.value = false
  currentDeleteRecord.value = null
}

// 打开签字确认弹窗
const signPayment = (record: PaymentApplicationItem) => {
  // 权限检查
  if(!userStore.userInfo.auths.includes('jf_p_p_s')){
    showError('您没有权限签字')
    return
  }

  // if(Number(record.status) === 1){
  //   showError('此付款申请已签字')
  //   return
  // }

  currentSignRecord.value = record
  signConfirmDialog.value = true
}

// 确认签字
const confirmSign = async () => {
  if (!currentSignRecord.value) return

  try {
    loading.value = true
    signConfirmDialog.value = false
    
    const response = await purchaseApi.purchasePaymentSign({
      id: currentSignRecord.value.id,
    })
    
    if (response.code === 0) {
      showSuccess('签字成功')
      await fetchPurchaseDetail()
    } else {
      showError(response.message)
    }
  } catch (error: any) {
    console.error('签字失败:', error)
    showError(error.message || error.msg)
  } finally {
    loading.value = false
    currentSignRecord.value = null
  }
}

// 取消签字
const cancelSign = () => {
  signConfirmDialog.value = false
  currentSignRecord.value = null
}

// 获取图片预览URL
const getImagePreviewUrl = (file: string | File | { url: string; name: string }) => {
  if (!file) return ''
  try {
    if (typeof file === 'string') {
      return file
    }
    if (file instanceof File) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'object' && 'url' in file) {
      return file.url
    }
    return ''
  } catch (error) {
    console.error('创建图片预览URL失败:', error)
    return ''
  }
}

const previewImage = ref<string[]>([])
const showPreview = ref(false)
const currentParentIndex = ref(0)
const selectedIndex = ref(0)
const isDelete = ref(false)
const type = ref<string>('voucher')
// 添加预览相关的方法
const handleImagePreview = (images: [], materialIndex: number, index: number, canDelete: boolean, isType: 'product' | 'wuliao' | 'voucher') => {
  console.log('images', images, materialIndex, index, canDelete, isType)
  // const urls = images.map(image => image.url)
  previewImage.value = images
  showPreview.value = true
  currentParentIndex.value = materialIndex
  selectedIndex.value = index
  isDelete.value = canDelete
  type.value = isType

}

onMounted(() => {
  // 加载仓库列表供发起采购弹窗使用
  loadWarehouseList()
  loadUnitList()
  userType.value = route.params.type as string || 'purchase'
  authkind.value = route.params.authkind as string || 'see'
  fetchPurchaseDetail()
})
</script>

<style lang="scss" scoped>
.purchase-detail-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-detail-table :deep(th) {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 0 0 0 8px!important;
  position: sticky;
  top: 0;
  z-index: 1;
}

.purchase-detail-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  padding: 0 0 0 8px!important;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.purchase-detail-table :deep(td) > * {
  max-width: 100%;
  /* margin-right: 8px; */
}

.product-table.purchase-detail-table :deep(td) > * {
  max-width: 100%;
  /* overflow: hidden; */
  overflow: visible;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.section-title {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  padding-left: 8px;
  border-left: 3px solid #D2475D;
}

/* 付款记录区块：白底黑字 */
.payment-record-block {
  background-color: #ffffff;
  color: #111111;
  padding: 16px 16px 24px;
  border-radius: 8px;
  box-sizing: border-box;
}

.payment-record-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 30px;
}

.payment-record-toolbar-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.payment-record-section-title {
  color: #111111 !important;
}

.payment-record-meta {
  color: #111111;
  font-size: 18px;
  margin-left: 18px;
}

.payment-record-table {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 18px;
}

.payment-record-block .payment-record-table :deep(th) {
  background-color: rgba(0, 0, 0, 0.04) !important;
  color: rgba(0, 0, 0, 0.87) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.payment-record-block .payment-record-table :deep(td) {
  color: #111111 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.payment-record-status {
  color: #111111;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background-color: rgba(255, 255, 255, 0.05);
}

:deep(.v-card-text) {
  padding-top: 24px !important;
}

/* 弹窗样式 */
.payment-dialog {
  background-color: #2B2D33 !important;
}

.payment-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.payment-dialog :deep(.v-card-text) {
  padding: 24px;
}

.payment-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.payment-dialog :deep(.v-autocomplete .v-field__input),
.payment-dialog :deep(.v-text-field .v-field__input),
.payment-dialog :deep(.v-autocomplete input),
.payment-dialog :deep(.v-text-field input) {
  color: #fff !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__outline),
.payment-dialog :deep(.v-text-field .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.payment-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.payment-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__append-inner i),
.payment-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.payment-dialog :deep(.v-text-field__suffix) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.payment-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.payment-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.payment-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.payment-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.payment-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.payment-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

/* 采购弹窗样式（与物料汇总页面保持一致） */
.purchase-dialog {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

/* 物料采购列表样式（从 MaterialListSummary 复制） */
.material-purchase-list {
  margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.material-purchase-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.material-purchase-item:last-child {
  border-bottom: none;
}

.material-purchase-item .item-content {
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
  word-break: break-all;
}

/* 左侧区域：序号 + 物料信息 */
.material-purchase-item .material-left-section {
  display: flex;
  align-items: center;
  width: 160px;
  min-width: 160px;
  flex-shrink: 0;
}

.material-purchase-item .material-index {
  color: #fff;
  margin-right: 10px;
  font-size: 14px;
  min-width: 20px;
}

.material-purchase-item .material-info {
  flex: 1;
}

.material-purchase-item .material-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  line-height: 1.4;
}

.material-purchase-item .material-spec {
  color: #b0b0b0;
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

.material-purchase-item .material-code {
  color: #898989;
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

/* 右侧区域：上下两行内容 */
.material-purchase-item .material-right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.material-purchase-item .top-content {
  display: flex;
  align-items: center;
}

.material-purchase-item .bottom-content {
  display: flex;
  align-items: center;
}

// 动画
.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
}

// 图片预览
.image-preview-item {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-actions {
  opacity: 1;
}

.image-preview-item .image-actions .v-icon {
  color: #fff;
  cursor: pointer;
}

.image-preview-item .image-actions .v-icon:hover {
  color: #ff5252;
}

.payment-type{
  width: 50px;
  padding: 4px 0px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  font-weight: 400;
  color: #E8E8E8;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
}
:deep(.mdi-calendar){
  color: #fff !important;
}

.payment-dialog :deep(.v-field){
  // height: 40px;
  box-sizing: border-box;
}

.payment-dialog :deep(.v-field__input),.payment-dialog :deep(.v-text-field__suffix){ 
  padding-top: 6px;
  padding-bottom: 6px;
  box-sizing: border-box;
  min-height: 40px;
}

.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(43, 45, 51, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.form-actions .v-btn {
  min-width: 120px;
}

.purchase-detail-page{
  padding-bottom: 80px!important;
}
</style> 